import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

export function useResponsive() {
  const breakpoints = useBreakpoints(breakpointsTailwind)

  const isSmallScreen = breakpoints.smaller('md')
  const isMediumScreen = breakpoints.between('md', 'lg')
  const isLargeScreen = breakpoints.greater('lg')

  return {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
  }
}
